<template>
    <info-popover content="This resource is licensed under by CC BY-SA 4.0" :placement="placement">
        <a :href="creativeCommonsUrl" target="_blank" rel="noopener">
            <img
                src="/static/general/img/icons/ccattribsharealike.svg"
                alt="Creative Commons Attribution-ShareAlike Logos"
                :height="height"
            />
        </a>
    </info-popover>
</template>

<script>
import InfoPopover from "@/components/InfoPopover"

export default {
    name: "CreativeCommonsIcon",
    props: {
        height: {
            type: String,
            default: "18px",
        },
        placement: {
            type: String,
            default: "bottom",
        },
    },
    components: {
        InfoPopover,
    },
    computed: {
        creativeCommonsUrl() {
            return this.$store.getters.creativeCommonsLicenseUrl
        },
    },
}
</script>
